const CONSTANTS_PEDIDOS = {
    TIPO_PAGO_CREDITO: "c81c314c-40a5-467c-b8ee-b2b6513b5704",
    TIPO_COMPROBANTE_DEFECTO: "d4521a44-ae7e-4a62-8797-b6c52e620488",
    TIPO_SEGURO_ESPECIAL: "4dcb41b2-625b-4a05-a45a-3d683b19fd06",
    TIPO_CLIENTE_DEFECTO: "ef376625-18f2-4506-8b20-d3eddc48514a",
    MD_PROD: "01",
    MD_SERV: "02",
};

const CONSTANTS_REPORTES = {
    TIPO_SERVICIO_VENTAS: "D4521A44-AE7E-4A62-8797-B6C52E620488",
    TIPO_SERVICIO_RENTALS: "6B4CB03A-D052-4850-96F7-04A8A6007966",
}

export {
    CONSTANTS_PEDIDOS, 
    CONSTANTS_REPORTES
};